export default __webpack_public_path__ + "static/media/logo-white.05ebbf6d.png";